import React from "react";
import PropTypes from "prop-types";
import { useNavigate } from "react-router-dom";

// @mui material components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";

// @mui icons
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";

// Re-use TutorialStep for consistent dialog styling
import TutorialStep from "../../tutorial/TutorialStep";

function LiveDemoRestriction({
    open,
    onClose,
    featureName = "This feature", // Default value
    helpText = null // Optional guidance text
}) {
    const navigate = useNavigate();

    const dialogContent = (
        <MDBox textAlign="center" px={2} pb={1} pt={2}>

            <MDTypography variant="h5" fontWeight="bold" color="dark" gutterBottom>
                Live Demo Mode
            </MDTypography>

            <MDTypography variant="body2" color="text" sx={{ mb: helpText ? 1 : 4, maxWidth: "90%", mx: "auto", opacity: 0.9 }}>
                As this is a live demo mode, <strong>{featureName}</strong> is not available.
            </MDTypography>

            {helpText && (
                <MDTypography
                    variant="caption"
                    color="text"
                    sx={{
                        mb: 2, // Reduced margin
                        display: "block",
                        maxWidth: "85%",
                        mx: "auto",
                        opacity: 0.8,
                        lineHeight: 1.4
                    }}
                >
                    {helpText}
                </MDTypography>
            )}

            {/* {helpText && typeof helpText === 'string' && helpText.includes("Social Stash") && (
                <MDButton
                    variant="gradient"
                    color="info"
                    size="small"
                    onClick={() => navigate("/social-stash")}
                    sx={{ px: 4, minWidth: "180px", mb: 4, mx: "auto", display: "block" }}
                >
                    GO TO SOCIAL STASH
                </MDButton>
            )} */}

            <MDBox
                px={2}
                py={2}
                borderRadius="lg"
                bgColor="grey-100"
                mx="auto"
                sx={{ border: "1px dashed #ced4da" }}
            >
                <MDTypography variant="body2" color="text" sx={{ mb: 1.5, display: 'block', opacity: 0.8 }}>
                    Start a free trial to access this feature in your own private workspace.
                </MDTypography>

                <MDBox
                    px={2}
                    py={0.5}
                    borderRadius="xl"
                    bgColor="rgba(0, 161, 161, 0.1)" // Light teal background
                    border="1px solid rgba(0, 161, 161, 0.3)" // Teal border matching intro
                    display="inline-block"
                >
                    <MDTypography variant="caption" fontWeight="bold" sx={{ color: "#00A1A1" }}>
                        Free 14-Day Trial &bull; No Credit Card &bull; Cancel Anytime
                    </MDTypography>
                </MDBox>
            </MDBox>

        </MDBox>
    );

    const dialogActions = (
        <MDBox width="100%" display="flex" flexDirection="column" gap={1} px={2} pb={2} alignItems="center">


            <MDButton
                variant="gradient"
                color="accent"
                size="small"
                // endIcon={<ArrowForwardIcon />}
                onClick={() => navigate("/auth/register")}
                sx={{ px: 4, minWidth: "180px" }}
            >
                START FREE TRIAL
            </MDButton>

            <MDButton
                variant="text"
                color="secondary"
                size="small"
                onClick={onClose}
                sx={{ opacity: 0.7 }}
            >
                Maybe Later
            </MDButton>
        </MDBox>
    );

    return (
        <TutorialStep
            open={open}
            onClose={onClose}
            content={dialogContent}
            actions={dialogActions}
            maxWidth="sm"
        />
    );
}

LiveDemoRestriction.propTypes = {
    open: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    featureName: PropTypes.string,
    helpText: PropTypes.node,
};

export default LiveDemoRestriction;
